import { render } from "./recolha_entrega.vue?vue&type=template&id=7ebf5a2e"
import script from "./recolha_entrega.vue?vue&type=script&lang=js"
export * from "./recolha_entrega.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__